/* eslint-disable */
import store from "../../store/index";
import axios from "axios";
import customModal from "../customModal/customModal.vue";

export default {
  name: "ActivateAccountPopup",
  components: { customModal },
  props: {
    patient: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.setRoleList();
    this.prefillFromPatient();
  },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      values: {
        userName: "",
        firstName: "",
        lastName: "",
        dateOfBirth: null,
        active: true,
        lock: false,               // Lock checkbox
        emailIdPrimary: "",
        emailIdSecondary: "",
        phoneNumber: "",
        userType: "External",
        role: "",
        addressLineOne: "",
        addressLineTwo: "",
        country: "",
        userId: "",
        isVerified: true,
        isPersonalInfoVerified: true,
      },
      roleList: [],
      multiSelectList: [""],
      validations: [false, false, false, false, false, false, false, false, false],
      errors: [],
      loading: false,
    };
  },
  methods: {
    prefillFromPatient() {
      if (!this.patient) return;
      this.values.firstName = this.patient.firstName || "";
      this.values.lastName = this.patient.lastName || "";
      this.values.emailIdPrimary = this.patient.email || "";
      this.values.phoneNumber = this.patient.phoneNumber || "";
    },

    async setRoleList() {
      const idtoken = store.getters.getIdToken;
      try {
        const res = await axios.get(`${this.baseurl}/account-core/roles/rolelist`, {
          headers: { Authorization: "Bearer " + idtoken },
        });
        this.roleList = res.data;
        const subjectRole = this.roleList.find(r => r.roleName === "Subject");
        if (subjectRole) {
          this.multiSelectList = [subjectRole.roleID];
        }
      } catch (err) {
        console.error("Failed to load roles", err);
      }
    },
    async ValidateEmail(mail) {
      if (mail !== "") {
        if (mail === this.values.emailIdPrimary) {
          this.validations[3] = false;
        } else if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
          this.validations[3] = true;
        } else {
          this.validations[3] = false;
        }
      } else {
        this.validations[3] = true;
      }
    },
    async ValidatefirstEmail(mail) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
        this.validations[2] = true;
      } else {
        this.validations[2] = false;
      }
    },
    async validPhone(phno) {
      if (phno === "") {
        this.validations[5] = true;
      } else if (phno.length === 10 && /^\d+$/.test(phno)) {
        this.validations[5] = true;
      } else {
        this.validations[5] = false;
      }
    },
    async validDob(dob) {
      if (dob === "") dob = null;
      let myDate = new Date(dob);
      let today = new Date();
      if (dob === null || dob === "") {
        this.validations[7] = true;
      } else if (myDate > today) {
        this.validations[7] = false;
      } else {
        this.validations[7] = true;
      }
    },
    async Validatename(name, errindex) {
      let letters = /^[A-Za-z\s]*$/;
      if (name.trim() === "") {
        this.validations[errindex] = false;
      } else if (!letters.test(name)) {
        this.validations[errindex] = false;
      } else {
        this.validations[errindex] = true;
      }
    },
    async ValidateUserName(name, errindex) {
      if (name === null || name === "") {
        this.validations[errindex] = false;
      } else if (name.length < 5 || name.length > 10) {
        this.validations[errindex] = false;
      } else {
        this.validations[errindex] = true;
      }
    },
    async validate() {
      this.values.firstName = this.values.firstName.replace(/ +/g, ' ').trim();
      this.values.lastName = this.values.lastName.replace(/ +/g, ' ').trim();
      this.values.userName = this.values.userName == null ? this.values.userName : this.values.userName.replace(/ +/g, ' ').trim();
      this.values.emailIdPrimary = this.values.emailIdPrimary.replace(/ +/g, ' ').trim();
      this.values.emailIdSecondary = this.values.emailIdSecondary.replace(/ +/g, ' ').trim();
      this.values.phoneNumber = this.values.phoneNumber.replace(/ +/g, ' ').trim();

      this.Validatename(this.values.firstName, 0);
      this.Validatename(this.values.lastName, 1);
      this.ValidateUserName(this.values.userName, 8);
      this.ValidatefirstEmail(this.values.emailIdPrimary);
      this.ValidateEmail(this.values.emailIdSecondary);
      this.validPhone(this.values.phoneNumber);

      if (this.values.userType !== "") {
        this.validations[4] = true;
      } else {
        this.validations[4] = false;
      }

      if (this.multiSelectList[0] && this.multiSelectList[0].length > 0) {
        this.validations[6] = true;
      } else {
        this.validations[6] = false;
      }

      this.validDob(this.values.dateOfBirth);
    },
    clearForm() {
      this.prefillFromPatient();
      this.values.dateOfBirth = null;
      this.values.emailIdSecondary = "";
      this.values.addressLineOne = "";
      this.values.addressLineTwo = "";
      this.values.country = "";
      this.values.userName = "";
      
      this.errors = [];
      this.validations = [false, false, false, false, false, false, false, false, false];
      const subjectRole = this.roleList.find(r => r.roleName === "Subject");
      if (subjectRole) {
        this.multiSelectList = [subjectRole.roleID];
      }
    },
  async addUser() {
  this.values.role = this.multiSelectList;

  await this.validate();
  if (this.validations.includes(false)) {
    this.errors = this.validations;
    alert("Please fix the errors before submitting.");
    return;
  }

  this.loading = true;

  // Step 1: Create the user
  try {
    await this.save(); // throws if creation fails
  } catch (err) {
    // Error already alerted inside save(), so just stop here
    this.loading = false;
    return;
  }

  // Step 2: If we reach here, user creation succeeded → activate the account
  try {
    const idtoken = store.getters.getIdToken;
    const activationPayload = {
      subjectID: this.patient.patientId,
      studyId: this.patient.studyId || "",
      siteId: this.patient.siteId || "",
      emailID: this.patient.email || this.values.emailIdPrimary,
      userId: this.values.userId,
      userName: this.values.userName,
      firstName: this.values.firstName,
      lastName: this.values.lastName,
      country: this.values.country,
      phoneNumber: this.values.phoneNumber,
      dateOfBirth: this.values.dateOfBirth,
    };

    await axios.post(
      `${this.baseurl}/account-core/user/activatepatientlogin`,
      activationPayload,
      { headers: { Authorization: "Bearer " + idtoken } }
    );

    this.$emit('saved');
    this.handleClose();
  } catch (err) {
    console.error("Activation failed:", err);
    const msg = err.response?.data?.detail || err.message || "Failed to activate account.";
    alert(msg);
  } finally {
    this.loading = false;
  }
},
  async save() {
  const idtoken = store.getters.getIdToken;
  try {
    await axios.post(
      `${this.baseurl}/account-core/user/createuser`,
      this.values,
      {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        },
      }
    );
    alert(this.$t('navigations.user created successfully') || "User created successfully.");
    // Success – resolve normally (no throw)
  } catch (err) {
    console.error("User creation error:", err);
    const detail = err.response?.data?.detail;
    if (detail === "Username already taken !") {
      alert(this.$t('navigations.username already taken') || "Username already taken.");
    } else if (err.response?.data?.messages?.[0]?.includes("The user already exists.")) {
      alert(this.$t('navigations.user exists with the same email') || "User exists with the same email.");
    } else {
      alert("Something went wrong while creating the user!");
    }
    // Rethrow the error so the caller knows creation failed
    throw err;
  }
},
    handleClose() {
      this.$emit('close');
    },
  },
};